module.exports = __webpack_public_path__ + "img/sg_dark.02a49e92.png";